module.exports = __webpack_public_path__ + "img/logo-qoe.e38fff43.jpg";